export enum ThriveCategory {
  ABOUT = "thrive/about-us",
  EVENTS = "thrive/events",
}
